import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { ICompanyComplianceNotification } from './ICompanyComplianceNotification'

export class CompanyComplianceNotification extends Entity<ICompanyComplianceNotification> {
  id: number
  organisationId: number
  companyId: number
  companyName?: string
  requirementTitle?: string

  public static new(
    payload: ICompanyComplianceNotification,
  ): CompanyComplianceNotification {
    return plainToInstance(CompanyComplianceNotification, payload)
  }
}
